import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress, Container, Typography } from "@mui/material";
import { pb } from "../services/pocketbase";

const DiscordCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleDiscordAuth = async () => {
      try {
        // Wait a moment for auth to be properly established
        await new Promise((resolve) => setTimeout(resolve, 500));

        console.log("Initial auth check:", {
          isValid: pb.authStore.isValid,
          userId: pb.authStore.model?.id,
        });

        if (!pb.authStore.isValid || !pb.authStore.model?.id) {
          throw new Error("PocketBase auth invalid");
        }

        // Navigate to account page after successful update
        navigate("/account");
      } catch (error) {
        console.error("Auth error:", error);
        navigate("/login?error=discord_sync_failed");
      }
    };

    handleDiscordAuth();
  }, [navigate]);

  return (
    <Container sx={{ textAlign: "center", mt: 4 }}>
      <CircularProgress />
      <Typography sx={{ mt: 2 }}>Linking Discord account...</Typography>
    </Container>
  );
};

export default DiscordCallback;
